import { POST } from "../APiHelper/API";
let source = null;
export const getCurrentUserBetsPrices = (onSuccess, onError) => {
    const data = {

    };
    source = POST("/api/v1/bets/prices", data, onSuccess, onError, true, source);
};